<!-- ModalComponent.vue -->
<template>
    <div v-if="show" class="modal-overlay" @click.self="close">
      <div class="modal-content">
        <div class="text-right extend-header">
            <!-- x -->
            <a class="shortcuts" @click="close">{{$t('calendar.buttons.close')}}</a>
        </div>
        <h3>{{$t('common.labels.productZaikoConfTitle')}}</h3>
        <div class="dropdown-container" v-if="selectedShouhinLst.length > 1">
          <select v-model="localSelectedFilter" @change="filterData">
            <option v-for="shouhin in selectedShouhinLst" :key="shouhin" :value="shouhin" :selected="shouhin === selectedShouhinLst[0]">
              {{ shouhin }}
            </option>
          </select>
        </div>
        <div v-else>
          <p>{{ selectedShouhinLst[0] }}</p>
        </div>
        <div class="table-container">
          <table class="inventory-table">
            <thead >
                <th class="date-header">{{$t('common.labels.syukkaYoteiYmd')}}</th>
                <th class="stock-header">{{$t('common.labels.productZaikoConfQty')}}</th>
            </thead>
            <tbody>
              <tr v-for="(row, index) in filteredData" :key="index">
                <td :class="{'highlight-saturday': row.day === '(土)','highlight-sunday': row.day === '(日)' || row.holiday === 1}">{{ row.ymd }} {{ row.day }}</td>
                <td :class="{'highlight-no-stock': row.hanbaiQty === 0}" style="text-align: right;">{{ formatNumber(row.hanbaiQty) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="note">
          <span v-html="note"></span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true
      },
      tableData: {
        type: Array,
        required: true
      },
      selectedShouhin: {
        type: String,
        required: true
      },
      selectedShouhinLst: {
        type: Array,
        required: true
      },
      note:String
    },
    data() {
      return {
        filteredData: [],
        localSelectedFilter: ''
      };
    },
    methods: {
      close() {
        this.$emit('close');
      },
      filterData() {
        if (this.localSelectedFilter) {
          this.filteredData = this.tableData.filter(row => row.shouhinCode === this.localSelectedFilter);
        } else {
          this.filteredData = this.tableData;
        }
      },
      formatNumber(value) {
        return value.toLocaleString('ja-JP');
      }
    },
    watch: {
      selectedFilter(newFilter) {
        this.localSelectedFilter = newFilter;
        this.filterData();
      },
      tableData() {
        this.filterData();
      },
      selectedShouhin(newShouhin) {
        this.localSelectedFilter = newShouhin;
        this.filterData();
      }
    },
    mounted() {
      if (this.selectedShouhinLst.length > 0) {
        this.localSelectedFilter = this.selectedShouhin === null ? this.selectedShouhinLst[0] : this.selectedShouhin;
      }
      this.filterData();
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .extend-header {
    display: flex;
    justify-content: flex-end;
  }

  .shortcuts {
    cursor: pointer;
    color: #007bff;
    text-decoration: none;
    padding: 5px 10px;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  .modal-content {
    top: 20px;
    padding: 20px;
    border-radius: 5px;
    position: relative;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .table-container {
    max-height: 60vh;
    overflow-y: auto;
    position: relative;
  }
  
  .inventory-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    table-layout: auto;
    display: table !important;
  }
  
  .inventory-table thead {
    top: 0;
    background-color: #00BFFF;
    break-inside: avoid;
    z-index: 2;
  }
  
  .inventory-table th,
  .inventory-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    white-space: nowrap;
  }
    
  .inventory-table th {
    background-color: #00BFFF;
    color: white;
  }
  
  .highlight-saturday {
    background-color: #E0FFFF;
  }
  
  .highlight-sunday {
    background-color: #FFB6C1;
  }
  
  .highlight-no-stock {
    background-color: #f0f0f0;
  }
  
  .note {
    margin-top: 10px;
    font-size: 0.9em;
    color: #555;
  }

  table td div:not(.agreement_desc):not(#membershipterms):not(.mente):not(#menteBox) {
      align-items: unset !important;
  }

  #sh030 tbody {
    display: revert !important;
  }

  #sh030 thead {
    display: revert !important;
  }

  </style>